import { useI18n } from '@radical/locale'
import { LAYOUT } from '../basic'

const { t } = useI18n()

const test: RouteRecordItem = {
  path: '/test',
  name: 'Test',
  component: LAYOUT,
  redirect: { name: 'TestCase' },
  meta: {
    title: t('routes.test.测试管理'),
    icon: 'mdi:test-tube',
    orderNo: 11,
    hideChildrenInMenu: true,
  },
  children: [
    {
      path: 'case',
      name: 'TestCase',
      component: () => import('@/pages/test/case.vue'),
      meta: {
        title: t('routes.test.测试用例'),
        icon: 'mdi:format-list-checks',
      },
    },
  ],
}

export default test
